import { http } from '../../../plugins/axios'
import { getFileErrorMessages } from '../../../plugins/constants'

const actions = {
  getInspectionsFilter ({commit}, payload) {
    let url = `inspections-filter`
    http.get(url, {params: payload.event.params})
      .then(response => {
        commit('onGetInspectionsFilter',  {event: payload.event, response})
      },
      error => {
        payload.event.context.showNotification(error.response, 'error')
      })
  },
  getInspectionsFilterDoc ({commit}, payload) {
    let url = `inspections-filter`
    http.get(url, {responseType: 'blob', params: payload.event.params})
      .then(response => {
        commit('onGetInspectionsFilterDoc',  {event: payload.event, response})
      },
      error => {
        payload.event.context.loadingButton = false
        getFileErrorMessages(error.response.data, payload.event.context.showNotification)
      })
  },
  getInspectionInspector ({commit}, payload) {
    let url = `pdf-inspector`
    http.get(url, {params: payload.event.params})
      .then(response => {
        commit('onGetInspectionInspector', {event: payload.event, response})
      },
      error => {
        payload.event.context.showNotification(error.response, 'error')
      })
  },
  getInspectionInspectorDoc ({commit}, payload) {
    let url = `pdf-inspector`
    http.get(url, {responseType: 'blob', params: payload.event.params})
      .then(response => {
        commit('onGetInspectionInspectorDoc',  {event: payload.event, response})
      },
      error => {
        payload.event.context.loadingButton = false
        getFileErrorMessages(error.response.data, payload.event.context.showNotification)
      })
  },
  getIncidentsInspector ({commit}, payload) {
    let url = `pdf-incidents`
    http.get(url, {params: payload.event.params})
      .then(response => {
        commit('onGetIncidentsInspector', {event: payload.event, response})
      },
      error => {
        payload.event.context.showNotification(error.response, 'error')
      })
  },
  getIncidentsInspectorDoc ({commit}, payload) {
    let url = `pdf-incidents`
    http.get(url, {responseType: 'blob', params: payload.event.params})
      .then(response => {
        commit('onGetIncidentsInspectorDoc',  {event: payload.event, response})
      },
      error => {
        payload.event.context.loadingButton = false
        getFileErrorMessages(error.response.data, payload.event.context.showNotification)
      })
  },
  getcheckList ({commit}, payload) {
    let url = `excel-checkList`
    http.get(url, {params: payload.event.params})
      .then(response => {
        commit('onGetcheckList', {event: payload.event, response})
      },
      error => {
        payload.event.context.showNotification(error.response, 'error')
      })
  },
  getcheckListDoc ({commit}, payload) {
    let url = `excel-checkList`
    http.get(url, {responseType: 'blob', params: payload.event.params})
      .then(response => {
        commit('onGetcheckListDoc',  {event: payload.event, response})
      },
      error => {
        payload.event.context.loadingButton = false
        getFileErrorMessages(error.response.data, payload.event.context.showNotification)
      })
  },
  getInspectionUnitType ({commit}, payload) {
    let url = `report-unit-index`
    http.get(url, {params: payload.event.params})
      .then(response => {
        commit('onGetInspectionUnitType', {event: payload.event, response})
      },
      error => {
        payload.event.context.showNotification(error.response, 'error')
      })
  },
  getInspectionUnitTypeDoc ({commit}, payload) {
    let url = `report-unit-excel`
    http.get(url, {responseType: 'blob', params: payload.event.params})
      .then(response => {
        commit('onGetInspectionUnitTypeDoc',  {event: payload.event, response})
      },
      error => {
        payload.event.context.loadingButton = false
        getFileErrorMessages(error.response.data, payload.event.context.showNotification)
      })
  },
  getQuestionnaires ({commit, dispatch}, payload) {
    let url = `questionnaires?perPage=-1&page=1`
    let options = {
      emulateJSON: false
    }
    http.get(url, {}, options)
      .then(response => {
        commit('onGetQuestionnaires',  {event: payload.event, response})
      },
      error => {
        payload.event.context.showNotification(error.response, 'error')
      })
  },
  getInspectionPointsWithDamages ({ commit }, payload) {
    let url = `inspection-points/damaged`
    http.get(url, { params: payload.event.params })
      .then(response => {
        commit('onGetInspectionPointsWithDamages', { event: payload.event, response })
      },
      error => {
        payload.event.context.showNotification(error.response, 'error')
        payload.event.context.loadingTable = false
      })
  },
  getInspectionPointsWithDamagesDoc ({ commit }, payload) {
    let url = `inspection-points/damaged`
    http.get(url, { responseType: 'blob', params: payload.event.params })
      .then(response => {
        commit('onGetInspectionPointsWithDamagesDoc', { event: payload.event, response })
      },
      error => {
        payload.event.context.loadingButton = false
        getFileErrorMessages(error.response.data, payload.event.context.showNotification)
      })
  },
  getOperatorCountDamaged ({ commit }, payload) {
    let url = `operator-count-damaged`
    http.get(url, { params: payload.event.params })
      .then(response => {
        commit('onGetOperatorCountDamaged', { event: payload.event, response })
      },
      error => {
        payload.event.context.showNotification(error.response, 'error')
        payload.event.context.loadingTable = false
      })
  },
  getOperatorCountDamagedDoc ({ commit }, payload) {
    let url = `operator-count-damaged` 
    http.get(url, { responseType: 'blob', params: payload.event.params })
      .then(response => {
        commit('onGetOperatorCountDamagedDoc', { event: payload.event, response })
      },
      error => {
        payload.event.context.loadingButton = false
        getFileErrorMessages(error.response.data, payload.event.context.showNotification)
      })
  },
  getInspectionUnitTypeIndexDoc ({commit}, payload) {
    let url = `report-unit-index`
    http.get(url, {responseType: 'blob', params: payload.event.params})
      .then(response => {
        commit('onGetInspectionUnitTypeIndexDoc',  {event: payload.event, response})
      },
      error => {
        payload.event.context.loadingButtonGeneral = false 
        getFileErrorMessages(error.response.data, payload.event.context.showNotification)
      })
  },
  getInspectionCountByUnit ({ commit }, payload) {
    let url = `report-inspection-count-by-unit`
    http.get(url, { params: payload.event.params })
      .then(response => {
        commit('onGetInspectionCountByUnit', { event: payload.event, response })
      },
      error => {
        payload.event.context.showNotification(error.response, 'error')
        payload.event.context.loadingTable = false
      })
  },
  getInspectionCountByUnitDoc ({ commit }, payload) {
    let url = `report-inspection-count-by-unit`
    http.get(url, { responseType: 'blob', params: payload.event.params })
      .then(response => {
        commit('onGetInspectionCountByUnitDoc', { event: payload.event, response })
      },
      error => {
        payload.event.context.loadingButton = false
        getFileErrorMessages(error.response.data, payload.event.context.showNotification)
      })
  },
  getInspectionCountByUnitDetails ({ commit }, payload) {
    let url = `report-inspection-count-by-unit/details`
    http.get(url, { params: payload.event.params })
      .then(response => {
        commit('onGetInspectionCountByUnitDetails', { event: payload.event, response })
      },
      error => {
        payload.event.context.showNotification(error.response, 'error')
        payload.event.context.loadingTable = false
      })
  },
  getTireChangeReport ({ commit }, payload) {
    let url = `report-tire-inspections`
    http.get(url, { params: payload.event.params })
      .then(response => {
        commit('onGetTireChangeReport', { event: payload.event, response })
      },
      error => {
        payload.event.context.showNotification(error.response, 'error')
        payload.event.context.loadingTable = false
      })
  },
  getTireChangeReportDoc ({ commit }, payload) {
    let url = `report-tire-inspections/export`
    http.get(url, { responseType: 'blob', params: payload.event.params })
      .then(response => {
        commit('onGetTireChangeReportDoc', { event: payload.event, response })
      },
      error => {
        payload.event.context.loadingButton = false
        getFileErrorMessages(error.response.data, payload.event.context.showNotification)
      })
  },
  getTireChangeReportDetails ({ commit }, payload) {
    let url = `report-tire-inspections/units/${payload.event.unitId}/inspections`
    http.get(url, { params: payload.event.params })
      .then(response => {
        commit('onGetTireChangeReportDetails', { event: payload.event, response })
      },
      error => {
        payload.event.context.showNotification(error.response, 'error')
        payload.event.context.loadingTable = false
      })
  },
}

export default actions